export const CONTACT = {
  phone: "722 29 49 23",
  phoneRaw: "+34722294923",
  whatsapp:
    "https://api.whatsapp.com/send?phone=34722294923&text=Hola%20Alejandro%2C%20necesitar%C3%ADa%20un%20presupuesto%20de%20fontaner%C3%ADa...",
};

export const LOGO =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/vpyuor9c_LogoCasa.jpg";

export const LOGO_TEXT =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/2psjrwd2_LogoLetras.jpg";

export const LOGO_FULL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/66uf0zfj_LogoCompleto.jpeg";

export const IMAGES = {
  // Hero cover — gloved plumber installing a faucet
  hero:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/nkiv38sm_Gemini_Generated_Image_rwbe7arwbe7arwbe.png",
  // Finished modern bathroom (walk-in shower + vanity) — reformas
  bathroom:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/1hx064gg_fontaneria-en-huelva-alejandro-17-scaled.webp",
  // Green water meter / contador with copper pipes — instalaciones
  meter:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/y0a66hx4_fontaneria-en-huelva-alejandro-18-scaled.webp",
  // Wall pipework during works — humedades y fugas
  wallPipes:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/tpod9joi_fontaneria-en-huelva-alejandro-19-scaled.webp",
  // Floor pipework during works — termos / saneamiento
  floorPipes:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/2c4843hm_fontaneria-en-huelva-alejandro-20-scaled.webp",
};

export const TRUST = [
  { title: "20 Años", text: "de experiencia en Huelva y alrededores." },
  { title: "Puntualidad", text: "Acudo siempre a la hora pactada." },
  { title: "Diagnóstico Real", text: "Sin cobros por averías inexistentes." },
  { title: "Solución Integral", text: "Fontanería y albañilería propia." },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Detección de averías complejas",
    text: "¿Humedades persistentes o fugas invisibles? Localizo el origen real del problema sin hacerte gastar de más en reparaciones innecesarias.",
  },
  {
    num: "02",
    title: "Honradez y transparencia",
    text: "Presupuestos claros y asesoramiento durante todo el proceso. Si algo no necesita cambiarse, te lo diré con total honestidad.",
  },
  {
    num: "03",
    title: "Trabajo limpio y rematado al 100%",
    text: "Contar con servicio de albañilería propio permite abrir, reparar y dejar tu pared o suelo arreglado sin tener que buscar a otro gremio.",
  },
  {
    num: "04",
    title: "Compromiso en las citas",
    text: "Con confirmación previa.",
  },
];

export const SERVICES = [
  {
    title: "Instalaciones de saneamiento soterrado",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/jfc31vgj_WhatsApp%20Image%202026-07-30%20at%2013.29.09%20%283%29.webp",
  },
  {
    title: "Instalaciones de puentes de contadores según normativa",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/clsjqnk4_Instalaciones%20de%20puentes%20de%20contadores%20segun%20normativa.webp",
  },
  {
    title: "Instalaciones de viviendas realizadas en multicapa con sistema press",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/rdhki1u0_WhatsApp%20Image%202026-07-30%20at%2013.29.09%20%285%29.webp",
  },
  {
    title: "Reparación de colectores y bajantes",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/b8q8lg1n_Reparaci%C3%B3n%20de%20colectores%20y%20bajantes.jpeg",
  },
  {
    title: "Instalación de baterías de contadores homologadas",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/ikvgqhsc_WhatsApp%20Image%202026-07-30%20at%2013.29.09%20%284%29.jpeg",
  },
  {
    title: "Renovación de instalaciones",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/qwvv68iv_WhatsApp%20Image%202026-07-30%20at%2013.29.09%20%286%29.webp",
  },
  {
    title: "Localización de fugas y reparación en acometidas generales de agua",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/ce3mazem_WhatsApp%20Image%202026-07-30%20at%2013.29.10%20%281%29.jpeg",
  },
  {
    title: "Instalación de filtros antibacterianos de plata",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/r0m11kk9_WhatsApp%20Image%202026-07-30%20at%2013.29.10%20%282%29.jpeg",
  },
  {
    title: "Sustitución e instalación de bajantes de PVC",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/imc7pxfg_WhatsApp%20Image%202026-07-30%20at%2013.29.10%20%283%29.webp",
  },
  {
    title: "Sistemas de filtración de ósmosis inversa",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/l4r1klzq_WhatsApp%20Image%202026-07-30%20at%2013.29.10%20%284%29.jpeg",
  },
  {
    title: "Instalación y asesoramiento de sistemas de filtración de agua",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/68kb5edo_WhatsApp%20Image%202026-07-30%20at%2013.29.10%20%285%29.jpeg",
  },
  {
    title: "Instalaciones con materiales específicos para laboratorios",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/s5pnig9e_WhatsApp%20Image%202026-07-30%20at%2013.29.10%20%287%29.jpeg",
  },
  {
    title: "Calentadores eléctricos, extra planos y aerotermia",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/wa2hr74m_WhatsApp%20Image%202026-07-30%20at%2013.29.10.jpeg",
  },
  {
    title: "Legalización de instalaciones de agua",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/n0kc1p1f_WhatsApp%20Image%202026-07-30%20at%2013.29.07.webp",
  },
  {
    title: "Instalaciones de agua calorifugadas",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/0zwxqsrv_WhatsApp%20Image%202026-07-30%20at%2013.29.10%20%286%29.webp",
  },
  {
    title: "Instalaciones de recogida de aguas pluviales",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/qtsehn9z_WhatsApp%20Image%202026-07-30%20at%2013.29.10%20%288%29.jpeg",
  },
  {
    title: "Instalación de desagües sobre planta",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/dbknnwhe_WhatsApp%20Image%202026-07-30%20at%2013.29.11.jpeg",
  },
  {
    title: "Instalación de bombas de drenaje y trituradoras",
    image:
      "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/tcxldfq8_WhatsApp%20Image%202026-07-30%20at%2013.29.09.jpeg",
  },
];


export const TESTIMONIALS = [
  {
    text: "Gran servicio, puntual y serio. Me resolvió un problema de humedades que, después de visitarme varios profesionales y cobrarme por averías que no existían, él me solucionó por fin. Todo seco hasta hoy.",
    author: "Adrian911",
    role: "Reseña verificada en Google",
  },
  {
    text: "Me cambió la tubería desde el contador hasta la vivienda (un tercero) y ha hecho un trabajo estupendo. Muy buen profesional y muy recomendable.",
    author: "Ana Rodríguez",
    role: "Local Guide",
  },
  {
    text: "Tanto él como su compañero albañil han hecho un trabajo fantástico para solucionarme un problema que me volvía loco en casa. Recomendable 100%.",
    author: "juan an",
    role: "Local Guide",
  },
  {
    text: "Sinceramente de los mejores. Vino a mirar el termo y de la nada se arregló, aún así no cobró el desplazamiento.",
    author: "Abraham Luna",
    role: "Reseña verificada",
  },
];

export const FAQS = [
  {
    q: "¿En qué zonas de Huelva trabajas?",
    a: "Atiendo en Huelva capital y municipios cercanos. Si tienes dudas sobre tu zona, escríbeme por WhatsApp y te confirmo al momento.",
  },
  {
    q: "¿Qué ocurre si la reparación requiere romper pared o suelo?",
    a: "Trabajo coordinado con profesional de albañilería para realizar el trabajo completo: apertura, reparación de fontanería y cierre perfecto. Te lo dejo listo para usar.",
  },
  {
    q: "¿Cómo puedo solicitar un presupuesto?",
    a: "Puedes llamarme directamente al 722 29 49 23 o enviarme una foto/vídeo de la avería por WhatsApp. También puedes rellenar el formulario de esta web y te contacto lo antes posible.",
  },
];

export const OTHER_SERVICES = [
  {
    title: "Instalación de servicios en obra nueva",
    text: "Proyectos de fontanería completos para viviendas y locales de nueva construcción, desde el diseño de la instalación hasta la puesta en marcha.",
    tag: "Obra nueva",
  },
  {
    title: "Servicios orientados a la albañilería",
    text: "Apertura, reparación y remate de paredes y suelos con equipo de albañilería propio para dejar cada trabajo terminado e impecable.",
    tag: "Albañilería",
  },
];

export const LEGAL_LINKS = [
  { slug: "aviso-legal", label: "Aviso Legal" },
  { slug: "politica-de-privacidad", label: "Política de Privacidad" },
  { slug: "politica-de-cookies", label: "Política de Cookies" },
];

export const LEGAL_CONTENT = {
  "aviso-legal": {
    title: "Aviso Legal",
    intro:
      "En cumplimiento de la Ley 34/2002, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se facilita la siguiente información:",
    sections: [
      {
        h: "Titular del sitio web",
        list: [
          { label: "Titular", value: "Alejandro García Gómez" },
          { label: "Actividad", value: "Servicios de fontanería y albañilería" },
          { label: "Ámbito", value: "Huelva capital y municipios cercanos" },
          { label: "CIF", value: "48945570Y" },
          { label: "Domicilio", value: "C/ Camarada Cerrejón Limón s/n" },
          { label: "Código postal", value: "21007" },
          { label: "Teléfono", value: "722 29 49 23" },
          { label: "Correo electrónico", value: "alexgarciamicuenta@gmail.com" },
          { label: "Nombre del dominio", value: "https://fontanerohuelva.com" },
        ],
      },
      {
        h: "Objeto",
        p: "Este sitio web tiene como finalidad ofrecer información sobre los servicios de fontanería prestados y facilitar el contacto y la solicitud de presupuesto por parte de los usuarios.",
      },
      {
        h: "Condiciones de uso",
        p: "El acceso a este sitio web es gratuito. El usuario se compromete a utilizar la web y sus contenidos conforme a la ley, la buena fe y el orden público, y a no emplearlos con fines ilícitos o lesivos.",
      },
      {
        h: "Propiedad intelectual",
        p: "Los contenidos, textos e imágenes de trabajos reales mostrados en esta web pertenecen a su titular. Queda prohibida su reproducción sin autorización expresa.",
      },
    ],
  },
  "politica-de-privacidad": {
    title: "Política de Privacidad",
    intro:
      "Conforme al Reglamento (UE) 2016/679 (RGPD) y a la Ley Orgánica 3/2018 (LOPDGDD), se informa sobre el tratamiento de los datos personales facilitados a través de esta web.",
    sections: [
      {
        h: "Responsable del tratamiento",
        p: "Alejandro García — Fontaneros en Huelva. Contacto: 722 29 49 23 · info@fontaneroenhuelva.es.",
      },
      {
        h: "Finalidad",
        p: "Los datos facilitados en el formulario de presupuesto (nombre, teléfono, tipo de servicio y mensaje) se utilizan exclusivamente para gestionar tu solicitud, elaborar el presupuesto y ponernos en contacto contigo.",
      },
      {
        h: "Legitimación",
        p: "La base legal es el consentimiento del interesado al enviar el formulario y la aplicación de medidas precontractuales a petición del usuario.",
      },
      {
        h: "Conservación y cesión",
        p: "Los datos se conservarán el tiempo necesario para atender tu solicitud y las obligaciones legales derivadas. No se cederán a terceros salvo obligación legal.",
      },
      {
        h: "Derechos",
        p: "Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad escribiendo a info@fontaneroenhuelva.es.",
      },
    ],
  },
  "politica-de-cookies": {
    title: "Política de Cookies",
    intro:
      "Esta web utiliza el mínimo de cookies necesarias para su correcto funcionamiento.",
    sections: [
      {
        h: "¿Qué son las cookies?",
        p: "Las cookies son pequeños archivos que se descargan en tu dispositivo al visitar determinadas páginas web y permiten, entre otras cosas, recordar preferencias del usuario.",
      },
      {
        h: "Cookies utilizadas",
        p: "Actualmente esta web solo emplea cookies técnicas necesarias para la navegación. No se utilizan cookies publicitarias ni de seguimiento de terceros.",
      },
      {
        h: "Gestión de cookies",
        p: "Puedes permitir, bloquear o eliminar las cookies instaladas mediante la configuración de las opciones de tu navegador.",
      },
    ],
  },
  "declaracion-de-accesibilidad": {
    title: "Declaración de Accesibilidad",
    intro:
      "Nos comprometemos a que este sitio web sea accesible para el mayor número de personas posible.",
    sections: [
      {
        h: "Compromiso",
        p: "Trabajamos para cumplir con las pautas de accesibilidad WCAG 2.1 en nivel AA, cuidando el contraste, la navegación por teclado y el uso de textos alternativos.",
      },
      {
        h: "Estado de cumplimiento",
        p: "Este sitio web es parcialmente conforme debido a que se encuentra en mejora continua. Seguimos revisando y corrigiendo posibles barreras de accesibilidad.",
      },
      {
        h: "Contacto y sugerencias",
        p: "Si detectas alguna dificultad de acceso o quieres hacernos una sugerencia, escríbenos a info@fontaneroenhuelva.es o llama al 722 29 49 23.",
      },
    ],
  },
};

// GALERÍA "MIS TRABAJOS"
// Para añadir fotos en el futuro, simplemente agrega objetos a este array.
// La cuadrícula crece automáticamente. Ejemplo:
//   { src: "https://.../foto1.jpg", alt: "Reparación de fuga en Huelva" },
export const GALLERY = [
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/sutbb2jd_fotoGaleria_1.webp",
    alt: "Instalación de tubería multicapa y saneamiento en pared realizada por fontanero en Huelva",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/2g9dtn0s_fotoGaleria_2.webp",
    alt: "Reforma de fontanería en cuarto de baño en obra en Huelva",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/8q8lznrp_fotoGaleria_3.webp",
    alt: "Instalación de tuberías vistas durante reforma integral en vivienda de Huelva",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/ichv4viq_fotoGaleria_4.webp",
    alt: "Bajante de PVC y saneamiento en pared abierta reparado por fontanero en Huelva",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/ful2701j_fotoGaleria_5.webp",
    alt: "Instalación de llave de corte general con bridas en acometida de agua en Huelva",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/65o88lfx_fontaneria-en-huelva-alejandro-24-scaled%20%281%29.webp",
    alt: "Reparación de tubería de cobre en pared abierta por fontanero profesional en Huelva",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/2ibbykpb_fontaneria-en-huelva-alejandro-34.jpg",
    alt: "Reparación de arqueta y red de saneamiento en suelo en vivienda de Huelva",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_huelva-plumbing-pro/artifacts/6qa7abih_fontaneria-en-huelva-alejandro-4.jpg",
    alt: "Instalación de tubería multicapa con accesorios de prensar en Huelva",
  },
];

// Número mínimo de huecos que se muestran mientras no haya fotos suficientes.
export const GALLERY_MIN_SLOTS = 0;

export const SERVICE_OPTIONS = [
  "Humedades y fugas",
  "Tuberías y multicapa",
  "Termos y grifería",
  "Reformas integrales",
  "Otro / no lo sé",
];
